import { render, staticRenderFns } from "./ShippingAddressView.vue?vue&type=template&id=1da52e7e&"
import script from "./ShippingAddressView.vue?vue&type=script&lang=ts&"
export * from "./ShippingAddressView.vue?vue&type=script&lang=ts&"
import style0 from "./ShippingAddressView.vue?vue&type=style&index=0&module=true&lang=stylus&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
